import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: null,
  loading: true,
  user: null,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    userLoaded: (state, action) => {
      state.isAuthenticated = true;
      state.loading = false;
      state.user = action.payload;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;
    },
    authError: (state, action) => {
      state.isAuthenticated = false;
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.loading = false;
      state.user = null;
      state.error = null;
    },
  },
});

export const {
  userLoaded,
  loginSuccess,
  authError,
  logout,
} = authSlice.actions;
export default authSlice.reducer;
